'use client'

import { useTranslations } from 'next-intl'
import { useMediaQuery } from '@/utils-ui'
import React, { useEffect, useState } from 'react'
import NextLink from 'next/link'
import classNames from 'classnames'
import { VideosProductContainer } from '@/components/pages/videos/index'
import { ScrollToTop } from '@/components/simple'
import { ICatalog, IProduct } from '@/entities'
import { Keyboard, Mousewheel } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/zoom'

type TVideosContainerProps = {
  catalogs: ICatalog[],
  products: IProduct[],
  product?: IProduct,
  searchParams?: { [key: string]: string | string[] | undefined }
}

const VideosContainer = ({ catalogs, products, product, searchParams }: TVideosContainerProps) => {
  const t = useTranslations('pages.videos')
  const searchCatalogAlias = searchParams?.catalog
  const searchProductAlias = searchParams?.product

  const isMobile: boolean = useMediaQuery('(max-width: 768px)')
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(false)

  useEffect(() => {
    setIsSmallScreen(isMobile)
  }, [isMobile])

  return (
    <main className='flex-grow-1'>
      <section className='video-section pt-150'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12 box-title'>
              <h2 className='green-stripes'>{t('title')}</h2>
            </div>

            <div className='col-12'>
              {!isSmallScreen && (
                <ul className='secondary-menu'>
                  {catalogs.map((x, index) => {
                    return (
                      <li key={index}>
                        <NextLink
                          href={{
                            pathname: `/videos`,
                            query: {
                              catalog: x.alias,
                            },
                          }}
                          className={classNames({ 'active': searchCatalogAlias === x.alias })}
                        >
                          {x.title}
                        </NextLink>
                      </li>
                    )
                  })}
                  <li>
                    <NextLink
                      href='/videos'
                      className={classNames({ 'active': !searchCatalogAlias })}
                    >
                      {t('secondary-menu.all-videos')}
                    </NextLink>
                  </li>
                </ul>
              )}

              {isSmallScreen && (
                <Swiper
                  wrapperTag="ul"
                  className='secondary-menu'
                  slidesPerView={'auto'}
                  mousewheel={true}
                  keyboard={true}
                  centeredSlides={false}
                  spaceBetween={5}
                  modules={[Mousewheel, Keyboard]}
                >
                  <SwiperSlide tag="li" style={{ width: 'auto', padding: '0 6px' }}>
                    <NextLink
                      href='/videos'
                      className={classNames({ 'active': !searchCatalogAlias })}
                    >
                      {t('secondary-menu.all-videos')}
                    </NextLink>
                  </SwiperSlide>

                  {catalogs.map((x, index) => {
                    return (
                      <SwiperSlide
                        key={index}
                        tag="li"
                        style={{ width: 'auto', padding: '0 6px' }}
                      >
                        <NextLink
                          href={{
                            pathname: `/videos`,
                            query: {
                              catalog: x.alias,
                            },
                          }}
                          className={classNames({ 'active': searchCatalogAlias === x.alias })}
                        >
                          {x.title}
                        </NextLink>
                      </SwiperSlide>
                    )
                  })}
                </Swiper>
              )}
            </div>
          </div>

          <div className='row'>
            {!isSmallScreen && (
              <div className='col-md-3 col-xxl-2 filter-menu'>
                <label>{t('filter-menu.title')}:</label>
                <ul>
                  {products.map((x, index) => {
                    return (
                      <li key={index}>
                        <NextLink
                          href={{
                            pathname: `/videos`,
                            query: {
                              ...searchParams,
                              product: x.alias,
                            },
                          }}
                          className={classNames({ 'active': searchProductAlias === x.alias || (!searchProductAlias && index === 0) })}
                        >
                          {x.title}
                        </NextLink>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )}

            {isSmallScreen && (
              <Swiper
                wrapperTag="ul"
                className='filter-menu'
                slidesPerView={'auto'}
                mousewheel={true}
                keyboard={true}
                centeredSlides={false}
                spaceBetween={5}
                modules={[Mousewheel, Keyboard]}
              >
                {products.map((x, index) => {
                  return (
                    <SwiperSlide
                      key={index}
                      tag="li"
                      style={{ width: 'auto', padding: '0 10px' }}
                    >
                      <NextLink
                        href={{
                          pathname: `/videos`,
                          query: {
                            ...searchParams,
                            product: x.alias,
                          },
                        }}
                        className={classNames({ 'active': searchProductAlias === x.alias || (!searchProductAlias && index === 0) })}
                      >
                        {x.title}
                      </NextLink>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            )}

            {product && (
              <VideosProductContainer product={product} />
            )}
          </div>

        </div>
      </section>

      <ScrollToTop />
    </main>
  )
}

export default VideosContainer